import { FlexBox, FInter , useIsMobile } from '@brg/ui';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import ShrinkIcon from 'shared/icons/ShrinkIcon';
import styled, { useTheme } from 'styled-components';

type PropsT = {
    onClick: Function;
    text?: string;
    height?:number;
};

export const TextBarWrapper = styled(FlexBox)`
    place-items: center;
    align-items: baseline;
    font-size: 15px;
    line-height: 20px;
    &:hover {
        * {
            color: ${p => p.theme.allTagsBtn.colorHover};
            fill: ${p => p.theme.allTagsBtn.colorHover};
        }
    }

    @media (max-width: 430px) {
      div {
        font-size: 13px !important;
        line-height: 18px !important;
      }
    }
`;

const TagsTextBar: FC<PropsT> = ({ onClick, text, height }) => {
    const theme = useTheme();
    const { t } = useTranslation();
    const isMobile = useIsMobile()
    return (
        <TextBarWrapper directionMobile="row" direction='row' onClick={() => onClick()}>
            <FInter.SmallTextMagic
              pointer={true}
              offsetTop={0}
              offsetRight={8}
              width={'auto'}
              height={height}
              align={'center'}
              color={theme.allTagsBtn.color}
            >
              {text || t('all_tags')}
            </FInter.SmallTextMagic>
            <ShrinkIcon />
        </TextBarWrapper>
    )
};

export default React.memo(TagsTextBar);
import { FlexBox, FInter , useIsMobile } from '@brg/ui';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import ShrinkIcon from 'shared/icons/ShrinkIcon';
import styled, { useTheme } from 'styled-components';

type PropsT = {
    onClick: Function;
    text?: string;
    height?:number;
};

export const TextBarWrapper = styled(FlexBox)`
    place-items: center;
    align-items: baseline;
    font-size: 15px;
    line-height: 20px;
    &:hover {
        * {
            color: ${p => p.theme.allTagsBtn.colorHover};
            fill: ${p => p.theme.allTagsBtn.colorHover};
        }
    }

    @media (max-width: 430px) {
      div {
        font-size: 13px !important;
        line-height: 18px !important;
      }
    }
`;

const TagsTextBar: FC<PropsT> = ({ onClick, text, height }) => {
    const theme = useTheme();
    const { t } = useTranslation();
    const isMobile = useIsMobile()
    return (
        <TextBarWrapper directionMobile="row" direction='row' onClick={() => onClick()}>
            <FInter.SmallTextMagic
              pointer={true}
              offsetTop={0}
              offsetRight={8}
              width={'auto'}
              height={height}
              align={'center'}
              color={theme.allTagsBtn.color}
            >
              {text || t('all_tags')}
            </FInter.SmallTextMagic>
            <ShrinkIcon />
        </TextBarWrapper>
    )
};

export default React.memo(TagsTextBar);
